// 2026-05-26 - FormuLearning - 에러 바운더리 (디버그용)
// 파일 위치: frontend/src/components/feedback/ErrorBoundary.tsx

import { Component } from 'react'
import type { ReactNode, ErrorInfo } from 'react'

interface Props {
  name: string
  children: ReactNode
}

interface State {
  error: Error | null
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`[ErrorBoundary:${this.props.name}]`, error.message, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 16, border: '1px solid red', borderRadius: 8, margin: 8, background: '#1a1b1e' }}>
          <p style={{ color: '#ff7a7a', fontSize: 12, fontWeight: 600 }}>Error in: {this.props.name}</p>
          <pre style={{ color: '#e8eaed', fontSize: 11, whiteSpace: 'pre-wrap', marginTop: 4 }}>{this.state.error.message}</pre>
        </div>
      )
    }
    return this.props.children
  }
}
